import { $api } from "../AxiosInstance";

export class TranslationPackagesService {
  /**
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   */

  static getAllTranslationPackagesWithParams(params) {
   return $api.post("/api/front/language-packages", params);

  }

  /**
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   */

  static getPaginationTranslationPackageWithParams(params) {
    return $api.post(
      "/api/front/language-package-pagination",
      params,
    );
  }

  /**
     * @param {Object} newLang
     * @param {String} newLang.languageId
     * @param {Boolean} newLang.isDefault
     * @param {String} newLang.comment
     * @param {Boolean} newLang.runTranslationProcess
     * @param {String} newLang.translatorId

     */

  static  addTranslationPackage(newLang) {
    return $api.post("/api/front/language-package", newLang);
  }

  /**
   * @param {String} id
   */

  static getTranslationPackageById(id) {
   return $api.get(`/api/front/language-package/${id}`);
  }

  /**
     * @param {Object} updateLungPackage
     * @param {String} updateLungPackage.id
     * @param {String} updateLungPackage.comment
     * @param {Boolean} updateLungPackage.isActive

     */

  static  updateTranslationPackageById( updateLungPackage) {
    return $api.patch(
      `/api/front/language-package/${updateLungPackage?.id}`,
      updateLungPackage,
    );
  }

  static getStatisticsTranslationPackageById(id) {
   return $api.get(
      `/api/front/language-package/percentage/${id}`,
    );
  }

  static  runTranslationProcess(id) {
    return $api.post(
      `/api/front/language-package/translate/${id}`,
    );
  }

  /**
   * @param {String} id
   */

  static deleteTranslationPackageById(id) {
    return $api.delete(`/api/front/language-package/${id}`);
  }
}
